import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";

import { Observable, BehaviorSubject, of } from "rxjs";
import { map } from "rxjs/operators";

import { HelpNavigationItem, HelpItem, HelpNav } from "../../models/help-library.model";
import { HelpLibraryService } from "../../services/help-library.service";

@Component({
    selector: 'app-help-library-viewer',
    templateUrl: './help-library-viewer.component.html',
    styleUrls: ['./help-library-viewer.component.scss'],
    standalone: false
})
export class HelpLibraryViewerComponent implements OnInit {

    _help: HelpNavigationItem;
    view$: Observable<SafeHtml>;

    get help(): HelpNavigationItem {
        return this._help;
    }

    set help(value: HelpNavigationItem) {
        this._help = value;
    }

    onHelpSet: BehaviorSubject<HelpNavigationItem> = new BehaviorSubject<HelpNavigationItem>(null);

    @Input() set navItem(val: HelpNavigationItem) {
        this._help = val;
        if ((this._help as HelpItem).data) {
            this.view$ = of(this.domSanitizer.bypassSecurityTrustHtml((this._help as HelpItem).data));
        } else {
            this.view$ = this.helpService.getHelp(this._help.id, this._help.categoryId).pipe(
                map(h => this.domSanitizer.bypassSecurityTrustHtml(h.data))
            );
        }
    }

    @Input() set view(val: string) {
        this.view$ = of(this.domSanitizer.bypassSecurityTrustHtml(val));
    }


    constructor(
        protected domSanitizer: DomSanitizer,
        protected helpService: HelpLibraryService,
        public activatedRoute: ActivatedRoute
    ) { }

    ngOnInit() {
        if (this.activatedRoute.data) {
            this.view$ = this.activatedRoute.data.pipe(
                map((result: { help: HelpItem }) => {
                    this._help = result.help;
                    this.helpService.setActiveNavItem(result.help as HelpNavigationItem);
                    return this.domSanitizer.bypassSecurityTrustHtml(result.help.data);
                })
            )
        }
    }

}
